import { render } from "./Diensten.vue?vue&type=template&id=77419eb8&scoped=true"
const script = {}

import "./Diensten.vue?vue&type=style&index=0&id=77419eb8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\reino\\Desktop\\testt\\de-tol\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77419eb8"]])

export default __exports__